import React, { ReactNode } from 'react'
import { FormattedMessage, IntlShape } from 'react-intl'

import { ProviderTriageRiskTaskArguments } from '@lyrahealth-inc/shared-app-logic/src/models/providers/Providers'

export type RiskDetailRow = {
  key: string
  label: ReactNode
  value: boolean | string | null | undefined
  alwaysError?: boolean
}

export const getRiskDetailRows = (args?: ProviderTriageRiskTaskArguments): RiskDetailRow[] => {
  const keyRisks = [args?.key_risk_si, args?.key_risk_sh].filter(Boolean).join(', ')

  return [
    {
      key: 'key_risks_shared',
      label: <FormattedMessage defaultMessage='Key risks shared:' description='Risk detail key risks' />,
      value: keyRisks || null,
      alwaysError: true,
    },
    {
      key: 'suicidal_thoughts',
      label: (
        <FormattedMessage
          defaultMessage='Suicidal thoughts in the last 2 weeks:'
          description='Risk detail suicidal thoughts'
        />
      ),
      value: args?.si_in_past_2_weeks,
    },
    {
      key: 'suicidal_thoughts_frequency',
      label: (
        <FormattedMessage
          defaultMessage='Frequency of suicidal thoughts:'
          description='Risk detail suicidal thoughts frequency'
        />
      ),
      value: args?.si_frequency,
      alwaysError: true,
    },
    {
      key: 'self_harm_plan',
      label: <FormattedMessage defaultMessage='Plan to end life:' description='Risk detail plan' />,
      value: args?.si_plan,
    },
    {
      key: 'self_harm_intent',
      label: <FormattedMessage defaultMessage='Intent within 24 hrs:' description='Risk detail intent' />,
      value: args?.si_plan_in_the_next_24_hours,
    },
    {
      key: 'steps_to_end_life',
      label: (
        <FormattedMessage defaultMessage='Taken steps to end their life:' description='Risk detail steps to end life' />
      ),
      value: args?.si_steps_taken,
    },
    {
      key: 'hospitalized',
      label: (
        <FormattedMessage
          defaultMessage='Hospitalized for mental health reasons:'
          description='Risk detail hospitalization'
        />
      ),
      value: args?.hospitalized,
    },
  ]
}

export const parseTaskDate = (date?: string | null, time?: string | null): string | null => {
  if (!date || !time) return null
  const parsed = new Date(`${date} ${time}`)
  return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString()
}

export const isUnacknowledgedTask = (task: {
  status?: string | null
  acknowledged_datetime?: string | null
}): boolean => task.status !== 'acknowledged' && !task.acknowledged_datetime

export const formatRiskValue = (value: boolean | string | null | undefined, intl: IntlShape): string => {
  if (typeof value === 'string') return value
  if (value === true)
    return intl.formatMessage({ defaultMessage: 'Yes', description: 'Affirmative value for risk detail field' })
  if (value === false)
    return intl.formatMessage({ defaultMessage: 'No', description: 'Negative value for risk detail field' })
  return intl.formatMessage({ defaultMessage: 'N/A', description: 'Not available value for risk detail field' })
}

export const isRiskPositive = (value: boolean | string | null | undefined): boolean => {
  if (typeof value === 'string') return value.toLowerCase() !== 'no'
  return value === true
}
